import {Constants} from './constants';
import {TimeStringPipe} from 'src/app/shared/pipes/time-string.pipe';

export function getCurrentStart(data, advanceChartPoint): number {
  return ((data.data.length - advanceChartPoint) * 100) / data.data.length;
}

export function getNewStart(newLen, currentStart, changingPointNumber): number {
  const oldStartIndex = ((newLen - changingPointNumber) * currentStart) / 100;
  return ((oldStartIndex + changingPointNumber) * 100) / newLen;
}

export function getNewEnd(newLen, currentEnd, changingPointNumber): number {
  const oldEndIndex = ((newLen - changingPointNumber) * currentEnd) / 100;
  return ((oldEndIndex + changingPointNumber) * 100) / newLen;
}

export function getMinXAxis(data, timeframe): number {
  return data.minTimestamp - timeframe.seconds * 1000;
}

export function getMaxXAxis(data, timeframe): number {
  return data.maxTimestamp + (timeframe.seconds / 2) * 1000;
}

export function getXAxis(
  type: string,
  data: any,
  timeframe: any,
  min = null,
  max = null,
  maxInterval = null,
): any {
  const timeString = new TimeStringPipe();

  return {
    type,
    min: min ? min : getMinXAxis(data, timeframe),
    max: max ? max : getMaxXAxis(data, timeframe),
    maxInterval: maxInterval ? maxInterval : timeframe.seconds * 1000,
    axisLabel: {
      show: true,
      textStyle: {
        color: '#FFFFFF',
      },
      formatter: (value, index) => {
        return timeString.transform(value, timeframe.name);
      },
      showMinLabel: false,
      showMaxLabel: false,
    },
    axisTick: {
      show: false,
    },
    splitLine: Constants.ChartCommon.LineChartOption,
    axisLine: Constants.ChartCommon.LineChartOption,
  };
}

export function getYAxis(type: string, name: string, mainChart = false): any {
  return {
    type,
    name,
    nameLocation: 'end',
    nameGap: 20,
    nameTextStyle: {
      color: '#FFFFFF',
      fontWeight: 'bold',
      padding: [0, 0, 0, -30],
    },
    boundaryGap: mainChart ? ['20%', '20%'] : true,
    axisLabel: {
      show: true,
      fontSize: 10,
      textStyle: {
        color: (value, index) => {
          if (+value === 0) {
            return '#FFCF07';
          } else if (+value > 0) {
            return '#FFFFFF';
          } else {
            return '#EC7D7D';
          }
        },
        fontWeight: 'bold',
      },
      showMinLabel: false,
    },
    splitLine: Constants.ChartCommon.LineChartOption,
    axisLine: Constants.ChartCommon.LineChartOption,
    axisTick: {
      show: false,
    },
  };
}

export function getDataZoom(start, end): any {
  return [
    {
      id: 'timeDataZoom',
      type: 'inside',
      xAxisIndex: 0,
      start,
      end,
      // TODO(hoangpq): Currently, do not allow zoom in and out by mouse wheel.
      // Plz support it in the future.
      zoomLock: true,
    },
  ];
}

export function roundMinutes(date): number {
  date.setMinutes(date.getMinutes() + 1);
  date.setSeconds(0);
  return date.getTime();
}
